export default __webpack_public_path__ + "static/media/Signup_2.c166414b.png";